import { gql } from "@apollo/client";

export const GET_MONTHLY_REPORT_BY_MONTH_AND_YEAR = gql`
  query GetMonthlyReportByMonthAndYear($year: Int!, $month: Int!) {
    getMonthlyReportByMonthAndYear(year: $year, month: $month) {
      id
      reportMonth
      reportYear
      lastMonthInvoiceValue
      invoicePercentChange
      totalVMs
      billingTypes
      totalAlerts
      alertsByType
      alertsByVM
      aiAlertAnalysis
      aiAlertRecommendation
      performanceData
      aiPerformanceAnalysis
      aiPerformanceRecommendation
      backupData
      aiBackupAnalysis
      aiBackupRecommendation
      financialData
      aiCostAnalysis
      aiCostRecommendation
      aiInfrastructureSummary
      createdAt
    }
  }
`;

export const GENERATE_MONTHLY_REPORT = gql`
  mutation GenerateMonthlyReport($year: Int!, $month: Int!) {
    generateMonthlyReport(year: $year, month: $month)
  }
`;